import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    constructor(
        private alertCtrl: AlertController,
        private toastCtrl: ToastController,
        private translate: TranslateService
    ) {}

    public async show(message: string) {
        message = await this.translate.get(message).toPromise();
        const alert = await this.alertCtrl.create({
            message,
            buttons: ['OK']
        });
        alert.present();
        return alert.onDidDismiss();
    }

    public async showConfirmation(
        header: string,
        message: string,
        confirmButton?: string,
        cancelButton?: string
    ): Promise<boolean> {
        header = await this.translate.get(header).toPromise();
        message = await this.translate.get(message).toPromise();
        if (confirmButton) {
            confirmButton = await this.translate.get(confirmButton).toPromise();
        }
        if (cancelButton) {
            cancelButton = await this.translate.get(cancelButton).toPromise();
        }

        return new Promise(async (resolve) => {
            const alert = await this.alertCtrl.create({
                header,
                message,
                buttons: [
                    {
                        text: cancelButton ? cancelButton : 'Cancel',
                        role: 'cancel',
                        handler: () => {
                            resolve(false);
                        }
                    },
                    {
                        text: confirmButton ? confirmButton : 'Yes',
                        handler: () => {
                            resolve(true);
                        }
                    }
                ]
            });
            alert.present();
        });
    }

    public async showCustomDismiss(
        header: string,
        message: string,
        confirmButton?: string,
        cssClass?: string
    ): Promise<boolean> {
        if (header) {
            header = await this.translate.get(header).toPromise();
        }
        message = await this.translate.get(message).toPromise();
        return new Promise(async (resolve) => {
            const alert = await this.alertCtrl.create({
                header,
                cssClass,
                message,
                backdropDismiss: false,
                buttons: [
                    {
                        text: confirmButton ? confirmButton : 'Yes',
                        handler: () => {
                            resolve(true);
                        }
                    }
                ]
            });
            alert.present();
        });
    }

    public async showToast(message: string, duration: number = 2000) {
        message = await this.translate.get(message).toPromise();
        const toast = await this.toastCtrl.create({
            message,
            duration
        });
        toast.present();
    }
}
